import { createFileRoute } from '@tanstack/react-router';
import { ComponentSheet } from '@/features/dev/component-sheet';

// /_dev/components: the S30 component sheet with the real components (P5.3).
export const Route = createFileRoute('/_dev/components')({
  component: ComponentSheet,
});
